import React, { useState, useEffect } from 'react';
import PrinceLogo from './images/Princelogo.png';
import './App.css';
import About from './BlenderPortfolio.js'
function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : 'auto';
  }, [menuOpen]);

  return (
    <header className="App-header">
      <nav className="navbar">
        <div className="logo-section">
          <img src={PrinceLogo} alt="Prince Logo" className="brand-logo" />
          <span className="brand-name">Code With Prince</span>
        </div>

        {/* Desktop Nav Links */}
        <ul className="nav-links desktop-nav">
          <li><a href="#">Home</a></li>
          <li><a href={About}>About</a></li>
          <li><a href="#">Projects</a></li>
          <li><a href="#">Contact</a></li>
        </ul>

        {/* Mobile Toggle Button */}
        <div className="menu-toggle" onClick={() => setMenuOpen(true)}>
          ☰
        </div>

        {/* Mobile Fullscreen Menu */}
        <div className={`mobile-menu ${menuOpen ? 'show' : ''}`}>
          <div className="close-btn" onClick={() => setMenuOpen(false)}>✕</div>
          <ul className="nav-links mobile-nav">
            <li><a href="#">Home</a></li>
            <li><a href="#">About</a></li>
            <li><a href="#">Projects</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;
